import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { Button } from './button';
import { createStyles } from '@/contexts/theme-context';
import { ExpandableTextShadow } from './expandable-text-shadow';
import { LinearGradient } from 'expo-linear-gradient';
import { Props } from './expandable-text-types';
import { setNextLayoutAnimation } from '@/utils/layout-animation';
import { Text, View } from 'react-native';

export const ExpandableText: React.FC<Props> = ({
  children,
  numberOfLines,
  textStyle,
  trackingData,
}) => {
  const [styles, theme] = useStyles();

  const [canExpand, setCanExpand] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <View style={styles.base} testID="expandable-text">
      <Text numberOfLines={expanded ? 0 : numberOfLines} style={textStyle}>
        {children}
      </Text>
      <ExpandableTextShadow
        numberOfLines={numberOfLines}
        setCanExpand={setCanExpand}
        textStyle={[textStyle, styles.textShadow]}
      >
        {children}
      </ExpandableTextShadow>
      {canExpand ? (
        <View style={styles.expandSection}>
          {!expanded ? (
            <LinearGradient
              colors={[`${theme.colors.white}00`, theme.colors.white]}
              end={[0, 1]}
              start={[0, 0]}
              style={styles.expandButtonBackground}
            />
          ) : null}
          <Button
            containerStyle={styles.expandButtonContainer}
            onPress={() => {
              setExpanded((e) => !e);
              setNextLayoutAnimation();
            }}
            size="xsmall"
            style={styles.expandButton}
            textStyle={styles.expandButtonText}
            trackingData={
              trackingData
                ? {
                    ...trackingData,
                    properties: {
                      ...trackingData.properties,
                      type: expanded ? 'collapse' : 'expand',
                    },
                  }
                : null
            }
            type="tertiary"
          >
            {expanded ? i18n.t('read_less') : i18n.t('read_more')}
          </Button>
        </View>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    overflow: 'hidden',
    paddingBottom: 28,
  },
  expandButton: {
    paddingHorizontal: 0,
  },
  expandButtonBackground: {
    height: 40,
  },
  expandButtonContainer: {
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.white,
  },
  expandButtonText: {
    color: theme.colors.primary,
  },
  expandSection: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
  },
  textShadow: {
    opacity: 0,
    position: 'absolute',
  },
}));
